module.exports = __webpack_public_path__ + "static/media/rebirth_14.d84f9da8.jpg";